export default __webpack_public_path__ + "static/media/photo--sm--104.8654e858.jpg";